import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
interface EnrollmentOfferProps {
  title?: string;
  includes: string[];
  oldPrice?: string;
  price: string;
  savings?: string;
  badge?: string;
  note?: string;
  buttonText?: string;
}
export function EnrollmentOffer({
  title = 'Ce primești și care este investiția ta',
  includes,
  oldPrice,
  price,
  savings,
  badge,
  note,
  buttonText = 'Click aici pentru înscriere! →'
}: EnrollmentOfferProps) {
  return <section className="bg-brand-beige section-padding" data-id="element-77">
      <div className="container-custom" data-id="element-78">
        <div className="max-w-3xl mx-auto bg-white rounded-[24px] shadow-xl border border-gray-100 p-8 md:p-12" data-id="element-79">
          <div className="text-center mb-10" data-id="element-80">
            <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-brand-navy mb-4" data-id="element-81">
              {title}
            </h2>
            <div className="w-16 h-1 bg-brand-gold mx-auto rounded-full" data-id="element-82"></div>
          </div>

          <div className="bg-brand-beige/30 rounded-[16px] p-6 md:p-8 mb-8" data-id="element-83">
            <p className="font-montserrat font-bold text-[14px] uppercase tracking-widest text-brand-navy mb-6" data-id="element-84">
              CE E INCLUS:
            </p>
            <ul className="space-y-4" data-id="element-85">
              {includes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-86">
                  <div className="mt-1 flex-shrink-0 w-5 h-5 rounded-full bg-brand-gold/20 flex items-center justify-center" data-id="element-87">
                    <CheckCircle2Icon size={14} className="text-brand-gold" data-id="element-88" />
                  </div>
                  <span className="font-source text-[16px] text-brand-text" data-id="element-89">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="bg-brand-beige/20 rounded-[16px] p-6 md:p-8 mb-8 border border-brand-beige/50" data-id="element-90">
            {oldPrice ? <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-91">
                <div className="text-center md:text-left" data-id="element-92">
                  <p className="font-montserrat font-bold text-[12px] uppercase tracking-widest text-brand-textSecondary mb-1" data-id="element-93">
                    VALOARE REALĂ
                  </p>
                  <p className="font-source text-[20px] text-brand-textSecondary line-through" data-id="element-94">
                    {oldPrice}
                  </p>
                </div>
                <div className="hidden md:block w-px h-12 bg-brand-beige/50" data-id="element-95"></div>
                <div className="text-center md:text-right flex flex-col items-center md:items-end" data-id="element-96">
                  <p className="font-montserrat font-bold text-[12px] uppercase tracking-widest text-brand-coral mb-1" data-id="element-97">
                    PREȚ SPECIAL
                  </p>
                  <p className="font-playfair font-bold text-[40px] md:text-[48px] text-brand-gold leading-none mb-2" data-id="element-98">
                    {price}
                  </p>
                  {savings && <span className="inline-block bg-green-100 text-green-700 font-montserrat font-bold text-[12px] px-3 py-1 rounded-full" data-id="element-99">
                      {savings}
                    </span>}
                </div>
              </div> : <div className="text-center" data-id="element-100">
                <p className="font-montserrat font-bold text-[12px] uppercase tracking-widest text-brand-coral mb-2" data-id="element-101">
                  PREȚ
                </p>
                <p className="font-playfair font-bold text-[40px] md:text-[48px] text-brand-gold leading-none" data-id="element-102">
                  {price}
                </p>
              </div>}
          </div>

          {badge && <div className="flex justify-center mb-6" data-id="element-103">
              <span className="inline-flex items-center gap-2 bg-red-50 text-red-600 font-montserrat font-bold text-[12px] px-4 py-1.5 rounded-full" data-id="element-104">
                🔥 {badge}
              </span>
            </div>}

          <a href="#inscriere" className="block w-full text-center bg-brand-gold text-brand-navy hover:bg-brand-navy hover:text-white transition-colors duration-300 font-montserrat font-bold text-[16px] md:text-[18px] py-4 md:py-5 rounded-[12px] shadow-lg mb-4" data-id="element-105">
            {buttonText}
          </a>

          {note && <p className="font-source text-[13px] text-brand-textSecondary text-center" data-id="element-106">
              {note}
            </p>}
        </div>
      </div>
    </section>;
}